import { api } from "@/services";

export const LanguageStateStatus = {
  NONE: "",
  ERROR: "error",
};

export const language = {
  namespaced: true,
  state: {
    items: [],
    status: LanguageStateStatus.NONE,
    error: {},
    totalItems: 0,
  },
  actions: {
    list({ commit, state }) {
      //* Lazy caching since languages, usually, don't suppose to change.
      if (!state.items.length) {
        commit("UNSET_ERROR");
        commit("UNSET_ITEMS");

        return api.language
          .list()
          .then((languages) => commit("SET_ITEMS", languages.data))
          .catch((error) => commit("SET_ERROR", error));
      }

      return Promise.resolve();
    },
    unsetItems({ commit }) {
      commit("UNSET_ITEMS");
    },
  },
  mutations: {
    UNSET_ITEMS(state) {
      state.items = [];
    },
    UNSET_ERROR(state) {
      state.error = {};
      state.status = LanguageStateStatus.NONE;
    },
    SET_ERROR(state, error) {
      state.error = error;
      state.status = LanguageStateStatus.ERROR;
    },
    SET_ITEMS(state, items) {
      let transformedItems = [];
      for (let item in items) {
        transformedItems.push({ id: item, name: items[item] });
      }
      state.items = transformedItems;
    },
  },
};

export default {
  language,
  LanguageStateStatus,
};
